import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "../../../plugins/gsap/SplitText";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

class BioFutureTextBlock {
    constructor(el) {
        this.el = el;
        this.headline = this.el.querySelector('h3');
        this.text = this.el.querySelector('.txt');

        if(this.headline) {
            this.splitText = new SplitText(this.headline, {type: "chars,words", reduceWhiteSpace:false});
            this.chars = this.splitText.chars;

            gsap.set(this.chars, {alpha: 0, y: 20});
        }

        if(this.text) {
            gsap.set(this.text, {alpha: 0, y: 50});
        }

        gsap.set(this.el, {alpha: 1});

        this.timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.el,
                start: "top 70%",
                end: "bottom 20%",
            }
        })
            .to(this.chars, {alpha: 1, y: 0, duration: 0.5, stagger: 0.035, ease: "expo.out"})
            .to(this.text, {alpha: 1, y: 0, duration: 1.15, ease: "expo.out"}, "-=0.45")
    }
}

export default BioFutureTextBlock
